export default {
    map_geofence_geofenceContacts_title: "Contacts alerts for Geofence: ",
    map_geofence_geofenceContacts_contacts: 'Contacts',
    map_geofence_geofenceContacts_noContacts: 'No contacts added'
};